<kendo-dialog-titlebar>
    
</kendo-dialog-titlebar>

<div  fxLayout="column" fxLayoutGap="15px">

    <div [innerHtml]="question | safe:'html'"></div>

    <div fxLayoutAlign="center center" fxLayoutGap="15px">
        <button type="button" kendoButton (click)="ok()">{{'global.close' | translate}}</button>
    </div>
</div>